import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const MentionsLegalesPage = () => {
  const navigate = useNavigate();

  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.5 }
  };

  const sections = [
    {
      title: '1. Editeur du site',
      content: `Le site Coach DIA est edite par AMSY ECOM, SAS au capital variable.
Siege social : France
Email : contact@coach-dia.com
Directeur de la publication : Olivier SYLLA`
    },
    {
      title: '2. Hebergement',
      content: `Le site est heberge par des prestataires d'hebergement cloud professionnels garantissant la securite et la disponibilite des services.`
    },
    {
      title: '3. Propriete intellectuelle',
      content: `L'ensemble des contenus presents sur le site Coach DIA (textes, images, logos, videos, modules de formation, algorithmes IA, interfaces) sont proteges par le droit de la propriete intellectuelle.

Toute reproduction, representation, modification, publication, adaptation de tout ou partie des elements du site, quel que soit le moyen ou le procede utilise, est interdite, sauf autorisation ecrite prealable de AMSY ECOM.

La marque Coach DIA, les logos et l'ensemble des signes distinctifs sont la propriete exclusive de AMSY ECOM.`
    },
    {
      title: '4. Donnees personnelles',
      content: `Conformement au Reglement General sur la Protection des Donnees (RGPD), les utilisateurs disposent d'un droit d'acces, de rectification, de suppression et de portabilite de leurs donnees personnelles.

Donnees collectees :
- Identite (nom, prenom, email)
- Donnees de connexion et de progression pedagogique
- Enregistrements audio des sessions de coaching IA (avec consentement)
- Donnees de session video (avec consentement)

Finalites :
- Fourniture du service de formation et de coaching
- Personnalisation du parcours pedagogique
- Generation de rapports IA post-session
- Amelioration continue de la plateforme

Les donnees sont conservees pendant la duree de l'abonnement et 3 ans apres la fin de la relation commerciale.

Pour exercer vos droits : contact@coach-dia.com`
    },
    {
      title: '5. Cookies',
      content: `Le site utilise des cookies essentiels au fonctionnement (authentification, preferences) et des cookies d'analyse (mesure d'audience).

Vous pouvez gerer vos preferences de cookies dans les parametres de votre navigateur.`
    },
    {
      title: '6. Intelligence artificielle',
      content: `Coach DIA utilise des technologies d'intelligence artificielle (OpenAI GPT-4o, Whisper) pour :
- Le coach vocal Owen (conversations en temps reel)
- L'assistante Elya (support et navigation)
- L'analyse post-session (rapports IA des sessions video)
- La transcription audio des sessions

Les modeles IA sont utilises en tant qu'outils d'aide a la formation. Ils ne remplacent pas l'expertise humaine et ne prennent aucune decision automatisee ayant des effets juridiques.

Les donnees transmises aux modeles IA sont traitees conformement au RGPD et ne sont pas utilisees pour l'entrainement de modeles tiers.`
    },
    {
      title: '7. Espace Coachs humains',
      content: `Coach DIA propose un Espace Coachs certifies permettant :
- La reservation de sessions de coaching en visio ou en presentiel
- L'enregistrement des sessions video avec consentement mutuel
- La generation automatique de rapports IA post-session

La confidentialite des echanges est strictement garantie :
- Le rapport global est partage entre coach et coache
- Le feedback prive du coach n'est visible que par le coach
- Le feedback prive de l'utilisateur n'est visible que par l'utilisateur

Les informations personnelles identifiables (emails, telephones) sont automatiquement filtrees dans le chat en session.`
    },
    {
      title: '8. Responsabilite',
      content: `AMSY ECOM s'efforce d'assurer l'exactitude et la mise a jour des informations diffusees sur le site. Toutefois, AMSY ECOM ne peut garantir l'exactitude, la precision ou l'exhaustivite des informations mises a disposition.

AMSY ECOM decline toute responsabilite pour toute imprecision, inexactitude ou omission portant sur des informations disponibles sur le site.`
    },
    {
      title: '9. Droit applicable',
      content: `Les presentes mentions legales sont soumises au droit francais. En cas de litige, les tribunaux francais seront seuls competents.

Derniere mise a jour : Avril 2026`
    }
  ];

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(to bottom, #FFF6E5 0%, #FBEAFF 50%, #E8F5FF 100%)' }}>
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 sm:pt-28 pb-16">
        <button
          onClick={() => navigate(-1)}
          data-testid="mentions-back-btn"
          className="inline-flex items-center gap-2 px-4 py-2 mb-8 rounded-full text-sm font-semibold
                     text-[#1C1147] bg-white/80 backdrop-blur border border-white/60
                     shadow-[0_1px_3px_rgba(28,17,71,0.06),0_4px_14px_rgba(28,17,71,0.08)]
                     hover:bg-white hover:shadow-[0_2px_6px_rgba(109,40,217,0.12),0_6px_20px_rgba(109,40,217,0.12)]
                     active:scale-95 transition-all duration-150"
        >
          <ArrowLeft className="w-4 h-4" /> Retour
        </button>

        <motion.div {...fadeInUp} className="mb-10">
          <div className="flex items-center gap-3 mb-3">
            <Shield className="w-7 h-7 text-[#8B5CF6]" />
            <h1 className="text-3xl sm:text-4xl font-black text-[#1C1147]" style={{ fontFamily: "'Manrope', sans-serif" }}>
              Mentions Legales
            </h1>
          </div>
          <p className="text-[#4B3869]">Informations legales relatives au site Coach DIA</p>
        </motion.div>

        <div className="space-y-8">
          {sections.map((section, i) => (
            <motion.div key={i} {...fadeInUp} transition={{ delay: i * 0.05 }}
              className="p-6 rounded-2xl" style={{ background: 'rgba(255,255,255,0.7)', backdropFilter: 'blur(12px)', border: '1px solid rgba(255,255,255,0.5)' }}>
              <h2 className="text-lg font-bold text-[#1C1147] mb-3">{section.title}</h2>
              <p className="text-sm text-[#3D2B73] leading-relaxed whitespace-pre-line">{section.content}</p>
            </motion.div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MentionsLegalesPage;
